export default __webpack_public_path__ + "static/media/Group 13000.e0739aea.svg";